export enum OtherSensorOptionEnum {
  LEAKAGE_1 = 'LEAKAGE_1',
  LEAKAGE_2 = 'LEAKAGE_2',
  LIGHT = 'LIGHT',
  SHAFT_CONTACT_1 = 'SHAFT_CONTACT_1',
  SHAFT_CONTACT_2 = 'SHAFT_CONTACT_2',
  SWITCHABLE_OUTPUT_1 = 'SWITCHABLE_OUTPUT_1',
  SWITCHABLE_OUTPUT_2 = 'SWITCHABLE_OUTPUT_2'
}
